

import React from 'react'
import { Box, SxProps, Typography, styled } from '@mui/material'
import { status_employee } from '../../pages/cms/personnel-management/enum/enum-personnel';
import { useTranslation } from 'react-i18next';


type Props = {
    type: string;
    text: string;
    transform?: string;
    sx?: SxProps;
    style?: React.CSSProperties
    disableMaxWidth?: boolean
}
type colorType = {
    id: string;
    color: string;
}
const statusBgColor: colorType[] = [
    {
        id: 'รอการตรวจสอบยอดเงิน', // i18n-ignore
        color: "#ECF4FC"
    },
    {
        id: 'Pending Payment Verification',
        color: "#ECF4FC"
    },
    {
        id: 'รอการสอบ', // i18n-ignore
        color: "#ECF4FC"
    },
    {
        id: 'Awaiting Examination',
        color: "#ECF4FC"
    },
    {
        id: 'รอกำหนดแจ้งการสอบ', // i18n-ignore
        color: "#ECF4FC"
    },
    {
        id: 'Pending Exam Notification',
        color: "#ECF4FC"
    },
    {
        id: 'waiting',
        color: "#ECF4FC"
    },
    {
        id: 'จัดทำโครงการ', // i18n-ignore
        color: "#ECF4FC"
    },
    {
        id: 'ยอมรับ', // i18n-ignore
        color: "#ECF4FC"
    },
    {
        id: 'warning',
        color: "#FFFAF2"
    },
    {
        id: 'pending',
        color: '#ECF4FC'
    },
    {
        id: 'Pending Complaint',
        color: '#ECF4FC'
    },
    {
        id: 'อยู่ระหว่างตรวจสอบ', // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: 'Recommend',
        color: '#ECF4FC'
    },
    {
        id: 'รอผลสอบสัมภาษณ์', // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: 'Waiting for Interview Result',
        color: '#ECF4FC'
    },
    {
        id: 'รออนุมัติ', // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: 'หน่วยงานเสนอโครงการ', // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: 'รอการชำระเงินค่าเทอม', // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: 'Pending Tuition Payment',
        color: '#ECF4FC'
    },
    {
        id: 'เปิดให้จอง', // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: 'ตรวจไปบางส่วน', // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: 'approve',
        color: '#F3FFF6'
    },
    {
        id: 'อนุมัติ', // i18n-ignore
        color: '#F3FFF6'
    },
    {
        id: 'ผ่าน', // i18n-ignore
        color: '#F3FFF6'
    },
    {
        id: 'อนุมัติการจอง', // i18n-ignore
        color: '#F3FFF6'
    },
    {
        id: 'Passed',
        color: '#F3FFF6'
    },
    {
        id: 'ผ่านการตรวจสอบ', // i18n-ignore
        color: '#F3FFF6'
    },
    {
        id: 'ใช้งาน', // i18n-ignore
        color: '#F3FFF6'
    },
    {
        id: 'reject',
        color: '#FFF6ED'
    },
    {
        id: 'ชำระไม่ผ่าน', // i18n-ignore
        color: '#FFF6ED'
    },
    {
        id: 'ไม่ผ่านการพิจารณา', // i18n-ignore
        color: '#FFF6ED'
    },
    {
        id: 'Rejected',
        color: '#FFF6ED'
    },
    {
        id: 'ไม่อนุมัติ', // i18n-ignore
        color: '#FFF6ED'
    },
    {
        id: 'Complaint Rejected',
        color: '#FFF6ED'
    },
    {
        id: 'ปฎิเสธเรื่องร้องเรียน', // i18n-ignore
        color: '#FFF3E4'
    },
    {
        id: 'ไม่อนุมัติการจอง', // i18n-ignore
        color: '#FFF3E4'
    },
    {
        id: 'send_back',
        color: '#FFFAF2'
    },
    {
        id: 'รอรับเรื่องร้องเรียน', // i18n-ignore
        color: '#FFFAF2'
    },
    {
        id: 'hot',
        color: '#FFFAF2'
    },
    {
        id: 'กำลังดำเนินการ', // i18n-ignore
        color: '#FFFAF2'
    },
    {
        id: 'รอยืนยันการชำระเงิน', // i18n-ignore
        color: '#FFFAF2'
    },
    {
        id: 'รอยืนยันการคืน', // i18n-ignore
        color: '#FFFAF2'
    },
    {
        id: 'รอยืนยันการยืม', // i18n-ignore
        color: '#FFFAF2'
    },
    {
        id: 'Waiting for Approval',
        color: '#FFFAF2'
    },
    {
        id: 'รอรับคำร้อง', // i18n-ignore
        color: '#FFFAF2'
    },
    {
        id: 'ส่งทบทวนชำระเงิน', // i18n-ignore
        color: '#FFFAF2'
    },
    {
        id: 'อยู่ระหว่างการประชุม', // i18n-ignore
        color: '#FFFAF2'
    },
    {
        id: 'ยังไม่ถึงวันที่เปิดให้จอง', // i18n-ignore
        color: '#FFFAF2'
    },
    {
        id: 'approve',
        color: '#F3FFF6'
    },
    {
        id: "ดำเนินการแล้วเสร็จ", // i18n-ignore
        color: "#F3FFF6"
    },
    {
        id: "success",
        color: "#ECFDF3"
    },
    {
        id: "ผ่านสอบสัมภาษณ์", // i18n-ignore
        color: "#ECFDF3"
    },
    {
        id: "Interview Passed",
        color: "#ECFDF3"
    },
    {
        id: "กำลังยืม", // i18n-ignore
        color: "#ECFDF3"
    },
    {
        id: "ตรวจสอบยอดเงินแล้ว", // i18n-ignore
        color: "#ECFDF3"
    },
    {
        id: "Payment Verified",
        color: "#ECFDF3"
    },
    {
        id: "ทบทวนสรุปผล", // i18n-ignore
        color: "#FFF6ED"
    },
    {
        id: "คืนแล้ว", // i18n-ignore
        color: "#FFF6ED"
    },
    {
        id: "ส่งทบทวน", // i18n-ignore
        color: "#FFF6ED"
    },
    {
        id: "ส่งทบทวนยอดเงิน", // i18n-ignore
        color: "#FFF6ED"
    },
    {
        id: "Payment Verified",
        color: "#FFF6ED"
    },
    {
        id: "เป็นบุคลากร", // i18n-ignore
        color: '#ECFDF3'
    },
    {
        id: "ยืนยันการชำระเงินแล้ว", // i18n-ignore
        color: '#ECFDF3'
    },
    {
        id: "รับเรื่องร้องเรียน", // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: "ร่าง", // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: "นัดหมายการประชุม", // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: "อาจารย์ผู้สอนหลัก", // i18n-ignore
        color: '#F0F9FF'
    },
    {
        id: "อาจารย์ผู้สอนร่วม", // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: "Meeting Scheduled",
        color: '#ECF4FC'
    },
    {
        id: "รอตรวจสอบการชำระเงิน", // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: "ยังไม่ถึงกำหนดประชุม", // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: "รอชำระเงิน", // i18n-ignore
        color: '#ECF4FC'
    },
    {
        id: "บันทึกร่าง", // i18n-ignore
        color: '#FFFAEB'
    },
    {
        id: "รอตรวจสอบ", // i18n-ignore
        color: '#FFFAEB'
    },
    {
        id: "Pending Verification",
        color: '#FFFAEB'
    },
    {
        id: "รอพิจารณา", // i18n-ignore
        color: '#FFFAEB'
    },
    {
        id: "ยังไม่ได้ตรวจ / รอตรวจ", // i18n-ignore
        color: '#FFFAEB'
    },
    {
        id: "รับคำร้อง", // i18n-ignore
        color: '#FFFAEB'
    },
    {
        id: "Save Draft",
        color: '#FFFAEB'
    },
    {
        id: "สิ้นสุดการเป็นบุคลากร", // i18n-ignore
        color: '#FEF3F2'
    },
    {
        id: "new",
        color: '#FEF3F2'
    },
    {
        id: "เกินกำหนดระยะเวลา", // i18n-ignore
        color: '#FEF3F2'
    },
    {
        id: "ยกเลิก", // i18n-ignore
        color: '#FEF3F2'
    },
    {
        id: "ปฏิเสธคำร้อง", // i18n-ignore
        color: '#FEF3F2'
    },
    {
        id: "เลยกำหนดการประชุม", // i18n-ignore
        color: '#FEF3F2'
    },
    {
        id: "ดำเนินการเสร็จสิ้น", // i18n-ignore
        color: "#ECFDF3"
    },
    {
        id: "ตรวจเสร็จแล้ว", // i18n-ignore
        color: "#ECFDF3"
    },
    {
        id: "ไม่ผ่านการสอบ", // i18n-ignore
        color: '#FEF3F2'
    },
    {
        id: "ไม่ผ่านการตรวจสอบ", // i18n-ignore
        color: '#FEF3F2'
    },
    {
        id: "Exam Failed",
        color: '#FEF3F2'
    },
    {
        id: "ไม่ผ่านสอบสัมภาษณ์", // i18n-ignore
        color: '#FEF3F2'
    },
    {
        id: "Interview Failed",
        color: '#FEF3F2'
    },
    {
        id: "กำลังศึกษา", // i18n-ignore
        color: "#ECFDF3"
    },
    {
        id: "Currently Studying",
        color: "#ECFDF3"
    },
    {
        id: "ยืนยันนักศึกษา", // i18n-ignore
        color: "#ECFDF3"
    },
    {
        id: "Student Confirmed",
        color: "#ECFDF3"
    },
    {
        id: "ผ่านการสอบ", // i18n-ignore
        color: "#ECFDF3"
    },
    {
        id: "Exam Passed",
        color: "#ECFDF3"
    },
    {
        id: "เสร็จสิ้น", // i18n-ignore
        color: "#ECFDF3"
    },
    {
        id: "รับหนังสือแล้ว", // i18n-ignore
        color: "#ECFDF3"
    },
]
const statusTextColor: colorType[] = [
    {
        id: 'รอการตรวจสอบยอดเงิน', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'Pending Payment Verification',
        color: '#0A77FF'
    },
    {
        id: 'รอผลสอบสัมภาษณ์', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'Waiting for Interview Result',
        color: '#0A77FF'
    },
    {
        id: 'รอการสอบ', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'Awaiting Examination',
        color: '#0A77FF'
    },
    {
        id: 'รอกำหนดแจ้งการสอบ', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'Pending Exam Notification',
        color: '#0A77FF'
    },
    {
        id: 'waiting',
        color: '#0A77FF'
    },
    {
        id: 'จัดทำโครงการ', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'ยอมรับ', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'pending',
        color: '#0A77FF'
    },
    {
        id: 'รอชำระเงิน', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'Pending Complaint',
        color: '#0A77FF'
    },
    {
        id: 'อยู่ระหว่างตรวจสอบ', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'Recommend',
        color: '#0A77FF'
    },
    {
        id: 'รออนุมัติ', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'ส่งทบทวน', // i18n-ignore
        color: '#C4320A'
    },
    {
        id: 'ทบทวนสรุปผล', // i18n-ignore
        color: '#C4320A'
    },
    {
        id: 'คืนแล้ว', // i18n-ignore
        color: '#C4320A'
    },
    {
        id: 'รอการชำระเงินค่าเทอม', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'Pending Tuition Payment',
        color: '#0A77FF'
    },
    {
        id: 'หน่วยงานเสนอโครงการ', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'เปิดให้จอง', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'ตรวจไปบางส่วน', // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: 'warning',
        color: '#EEA23E'
    },
    {
        id: 'ส่งทบทวน', // i18n-ignore
        color: '#EEA23E'
    },
    {
        id: 'ส่งทบทวนยอดเงิน', // i18n-ignore
        color: '#EEA23E'
    },
    {
        id: 'Payment Review Requested',
        color: '#EEA23E'
    },
    {
        id: 'ไม่ผ่านการพิจารณา', // i18n-ignore
        color: '#C8322B'
    },
    {
        id: 'Rejected',
        color: '#C8322B'
    },
    {
        id: 'reject',
        color: '#C8322B'
    },
    {
        id: 'ชำระไม่ผ่าน', // i18n-ignore
        color: '#C8322B'
    },
    {
        id: 'ไม่อนุมัติ', // i18n-ignore
        color: '#C8322B'
    },
    {
        id: 'Complaint Rejected',
        color: '#C8322B'
    },
    {
        id: 'ปฎิเสธเรื่องร้องเรียน', // i18n-ignore
        color: '#C8322B'
    },
    {
        id: 'ไม่อนุมัติการจอง', // i18n-ignore
        color: '#C8322B'
    },
    {
        id: 'ไม่ผ่านการสอบ', // i18n-ignore
        color: '#C8322B'
    },
    {
        id: 'ไม่ผ่านการตรวจสอบ', // i18n-ignore
        color: '#C8322B'
    },
    {
        id: 'Exam Failed',
        color: '#C8322B'
    },
    {
        id: 'ตรวจสอบยอดเงินแล้ว', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'Payment Verified',
        color: '#2AA63C'
    },
    {
        id: 'ตรวจเสร็จแล้ว', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'ยืนยันนักศึกษา', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'Student Confirmed',
        color: '#2AA63C'
    },
    {
        id: 'กำลังศึกษา', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'Currently Studying',
        color: '#2AA63C'
    },
    {
        id: 'approve',
        color: '#2AA63C'
    },
    {
        id: 'อนุมัติ', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'ใช้งาน', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'ผ่านสอบสัมภาษณ์', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'Interview Passed',
        color: '#2AA63C'
    },
    {
        id: 'กำลังยืม', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'ผ่านการสอบ', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'ผ่าน', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'Passed',
        color: '#2AA63C'
    },
    {
        id: 'ผ่านการตรวจสอบ', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'Exam Passed',
        color: '#2AA63C'
    },
    {
        id: 'close',
        color: '#FF8000'
    },
    {
        id: 'send_back',
        color: '#EEA23E'
    },
    {
        id: 'รอรับเรื่องร้องเรียน', // i18n-ignore
        color: '#EEA23E'
    },
    {
        id: 'hot',
        color: '#EEA23E'
    },
    {
        id: 'กำลังดำเนินการ', // i18n-ignore
        color: '#EEA23E'
    },
    {
        id: 'รอยืนยันการชำระเงิน', // i18n-ignore
        color: '#EEA23E'
    },
    {
        id: 'รอยืนยันการคืน', // i18n-ignore
        color: '#EEA23E'
    },
    {
        id: 'รอยืนยันการยืม', // i18n-ignore
        color: '#EEA23E'
    },
    {
        id: 'Waiting for Approval',
        color: '#EEA23E'
    },
    {
        id: 'รอรับคำร้อง', // i18n-ignore
        color: '#EEA23E'
    },
    {
        id: 'ส่งทบทวนชำระเงิน', // i18n-ignore
        color: '#EEA23E'
    },
    {
        id: "เป็นบุคลากร", // i18n-ignore
        color: '#0F9F0C'
    },
    {
        id: "ยืนยันการชำระเงินแล้ว", // i18n-ignore
        color: '#0F9F0C'
    },
    {
        id: "รับเรื่องร้องเรียน", // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: "นัดหมายการประชุม", // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: "อาจารย์ผู้สอนหลัก", // i18n-ignore
        color: '#026AA2'
    },
    {
        id: "อาจารย์ผู้สอนร่วม", // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: "Meeting Scheduled",
        color: '#0A77FF'
    },
    {
        id: "ร่าง", // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: "รอตรวจสอบการชำระเงิน", // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: "ยังไม่ถึงกำหนดประชุม", // i18n-ignore
        color: '#0A77FF'
    },
    {
        id: "บันทึกร่าง", // i18n-ignore
        color: '#B54708'
    },
    {
        id: "Save Draft",
        color: '#B54708'
    },
    {
        id: "ยังไม่ถึงวันที่เปิดให้จอง", // i18n-ignore
        color: '#B54708'
    },
    {
        id: "รอตรวจสอบ", // i18n-ignore
        color: '#B54708'
    },
    {
        id: "Pending Verification",
        color: '#B54708'
    },
    {
        id: "รอพิจารณา", // i18n-ignore
        color: '#B54708'
    },
    {
        id: "ยังไม่ได้ตรวจ / รอตรวจ", // i18n-ignore
        color: '#B54708'
    },
    {
        id: "รับคำร้อง", // i18n-ignore
        color: '#B54708'
    },
    {
        id: "อยู่ระหว่างการประชุม", // i18n-ignore
        color: '#B54708'
    },
    {
        id: "สิ้นสุดการเป็นบุคลากร", // i18n-ignore
        color: '#B42318'
    },
    {
        id: "new",
        color: '#B42318'
    },
    {
        id: "เกินกำหนดระยะเวลา", // i18n-ignore
        color: '#B42318'
    },
    {
        id: "ยกเลิก", // i18n-ignore
        color: '#B42318'
    },
    {
        id: "ไม่ผ่านสอบสัมภาษณ์", // i18n-ignore
        color: '#B42318'
    },
    {
        id: "Interview Failed",
        color: '#B42318'
    },
    {
        id: "ปฏิเสธคำร้อง", // i18n-ignore
        color: '#B42318'
    },
    {
        id: "เลยกำหนดการประชุม", // i18n-ignore
        color: '#B42318'
    },
    {
        id: 'ดำเนินการเสร็จสิ้น', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'ผ่าน', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'อนุมัติการจอง', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'เสร็จสิ้น', // i18n-ignore
        color: '#2AA63C'
    },
    {
        id: 'รับหนังสือแล้ว', // i18n-ignore
        color: '#2AA63C'
    },
]
const StatusCustom: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const StatusContainer = styled(Box)({
        width: "100%",
        maxWidth: props.disableMaxWidth ? '' : 150,
        height: 30,
        display: 'flex',
        justifyContent: "center",
        alignItems: "center",
        transform: props.transform ? props.transform : '',
        padding: "8px 8px",
        borderRadius: '16px',
        color: `${statusTextColor?.find((list) => list.id.toUpperCase() === props.type.toUpperCase())?.color} !important`,
        backgroundColor: statusBgColor?.find((list) => list.id.toUpperCase() === props.type.toUpperCase())?.color
    })

    return (
        <div className='flex justify-center'>
            <StatusContainer style={props.style} sx={{ ...props.sx }}>
                <li className='text-center'> {typeof props.text === 'string' && /[฀-๿]/.test(props.text) ? t(props.text.trim(), { context: "status" }) : props.text}</li>
            </StatusContainer>
        </div>

    )
}

export default StatusCustom